import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { FinanceService } from '../services/finance.service';
import { map, catchError, of, switchMap, take } from 'rxjs';

export const householdGuard: CanActivateFn = () => {
  const financeService = inject(FinanceService);
  const router = inject(Router);

  return financeService.household$.pipe(
    take(1),
    switchMap(cached => {
      if (cached !== undefined) {
        // Cache populated: either has household (allow) or confirmed null (redirect)
        if (cached !== null) return of(true);
        router.navigate(['/household/setup']);
        return of(false);
      }

      // Cache not yet populated — fetch from API (tap in service will update cache)
      return financeService.getHousehold().pipe(
        map(response => {
          if (response.data?.household) return true;
          router.navigate(['/household/setup']);
          return false;
        }),
        catchError(() => {
          router.navigate(['/household/setup']);
          return of(false);
        })
      );
    })
  );
};
